var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.0825 21.3498C43.0825 33.0785 33.5747 42.5866 21.8461 42.5866C10.1174 42.5866 0.609497 33.0785 0.609497 21.3498C0.609497 9.62119 10.1174 0.113281 21.8461 0.113281C33.5746 0.113281 43.0825 9.62119 43.0825 21.3498",
    fill: "#00A478"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6683 20.9772V17.2619H14.6293V14.0054H28.7103V17.3078H23.6713V20.9772H19.6683Z",
    fill: "#00A478"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5519 19.1426C26.5903 19.1426 30.6398 20.1514 30.6407 21.3896C30.6407 22.6281 26.5909 23.6377 21.5519 23.6377C16.513 23.6377 12.463 22.628 12.463 21.3896C12.4639 20.1514 16.5135 19.1426 21.5519 19.1426ZM21.5519 19.5098C16.2775 19.5098 13.5466 20.8861 13.2169 21.3906C13.5481 21.8493 16.2794 22.5371 21.5519 22.5371C26.8726 22.5371 29.5574 21.8493 29.8878 21.3906C29.5582 20.932 26.8264 19.5098 21.5519 19.5098Z",
    fill: "#00A478"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6712 22.1242V19.5556C23.0119 19.5097 22.3055 19.4639 21.5991 19.4639C20.9398 19.4639 20.3275 19.4639 19.7153 19.5097V22.0783C20.2805 22.0783 20.9398 22.1242 21.5991 22.1242C22.3055 22.17 23.0119 22.17 23.6712 22.1242Z",
    fill: "#00A478"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.552 23.6381C20.8926 23.6381 20.2804 23.6381 19.6682 23.5923V30.4265H23.6241V23.5464C22.9648 23.5923 22.2584 23.6381 21.552 23.6381Z",
    fill: "#00A478"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.fdebd078c9a76db566f346c6b1e9ad0e.svg";
export { ForwardRef as ReactComponent };